module.exports = __webpack_public_path__ + "img/pause.ffd992b2.svg";